import React from 'react';
import { MailIcon, FileTextIcon, ShieldAlertIcon } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageProvider';
import { LanguageToggle } from './LanguageToggle';
const LINK_HREFS = ['#el-caso', '#el-patron', '#la-organizacion', '#el-metodo', '#linea-de-tiempo'];
export function SiteFooter() {
  const {
    t
  } = useLanguage();
  return <footer id="contacto" className="scroll-mt-28 border-t-4 border-double border-ink bg-ink text-paper" data-id="element-69" data-mp="3hgdf9xgx33c7">
      <div className="mx-auto grid max-w-6xl gap-10 px-4 py-12 md:grid-cols-3" data-id="element-70" data-mp="3derwxwlm5wum">
        <div data-id="element-71" data-mp="38ggjzd00v686">
          <p className="text-[10px] uppercase tracking-[0.35em] text-paper/50" data-id="element-72" data-mp="38jup2t02ltjb">{t.brand.kicker}</p>
          <p className="mt-1 font-serif text-2xl font-black" data-id="element-73" data-mp="33krj96c9njaa">
            {t.brand.title} <span className="text-accent" data-id="element-74" data-mp="2yl558uom5z0f">{t.brand.titleAccent}</span>
          </p>
          <p className="mt-3 max-w-xs text-sm leading-relaxed text-paper/70" data-id="element-75" data-mp="11q0na5734om3">{t.footer.about}</p>
          <div className="mt-5" data-id="element-76" data-mp="wta59cbpziy1">
            <LanguageToggle tone="dark" data-id="element-77" data-mp="wq4gjy706j2u" />
          </div>
        </div>

        <div data-id="element-78" data-mp="15q2cqv3tjgcd">
          <h2 className="flex items-center gap-2 text-[12px] font-bold uppercase tracking-[0.18em] text-paper/60" data-id="element-79" data-mp="15pk4f03vtbo3">
            <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-80" data-mp="1anvhrktdy4b2" />
            {t.footer.testimonyTitle}
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-paper/70" data-id="element-81" data-mp="10rsfmeyja5o4">{t.footer.testimonyText}</p>
          <a href="mailto:desennchufalo@gmail.com" className="mt-4 inline-block border border-paper/30 px-4 py-2 text-sm font-semibold uppercase tracking-[0.12em] transition-colors hover:border-accent hover:bg-accent" data-id="element-82" data-mp="1ohcxsvmv4ywc">
            {t.footer.testimonyCta}
          </a>
        </div>

        <div data-id="element-83" data-mp="1jq4odzlj9dj6">
          <h2 className="flex items-center gap-2 text-[12px] font-bold uppercase tracking-[0.18em] text-paper/60" data-id="element-84" data-mp="1jpuwu7kuaybd">
            <FileTextIcon className="h-4 w-4" aria-hidden="true" data-id="element-85" data-mp="27ffiwzcaibov" />
            {t.footer.sections}
          </h2>
          <ul className="mt-3 space-y-2 text-sm text-paper/70" data-id="element-86" data-mp="2c8igrjo3o7av">
            {t.footer.links.map((label, i) => <li key={label} data-id="element-87" data-mp="2m0tmfnjc8lep" data-mpi={i}>
                <a href={LINK_HREFS[i]} className="transition-colors hover:text-accent" data-id="element-88" data-mp="2h42yke1akliq">
                  {label}
                </a>
              </li>)}
          </ul>
        </div>
      </div>

      <div className="border-t border-paper/15" data-id="element-89" data-mp="283oax80uuuc2">
        <div className="mx-auto flex max-w-6xl flex-col gap-2 px-4 py-5 text-[12px] text-paper/50 sm:flex-row sm:items-center sm:justify-between" data-id="element-90" data-mp="282vccuc1vb50">
          <p className="flex items-center gap-2" data-id="element-91" data-mp="1yctkrskhnalc">
            <ShieldAlertIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-92" data-mp="1yc0oxmn2i5hz" />
            {t.footer.disclaimer}
          </p>
          <p data-id="element-93" data-mp="1tbw8txq2ncsa">{t.footer.rights}</p>
        </div>
      </div>
    </footer>;
}